import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from './components/ui/error-fallback';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import * as Sentry from '@sentry/react';
import App from './App.tsx';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.25,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/hanly-api-dev\.fly\.dev\/api/,
    /^https:\/\/hanly-api-prod\.fly\.dev\/api/,
    /^https:\/\/internal-api\.animal-office\.jp\/api/,
  ],
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find the root element');
}

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, info) => {
        Sentry.captureException(error, {
          extra: { componentStack: info?.componentStack },
        });
      }}
    >
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
